import { motion } from 'framer-motion';
import { MagnifyingGlass, Tag, Compass, Users } from '@phosphor-icons/react';

const fadeInUp = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.5 }
};

const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};

const FeaturesSection = () => {
  const features = [
    {
      icon: MagnifyingGlass,
      title: "Find Great Wineries",
      description: "Discover 500+ wineries in Napa Valley & Sonoma with GPS-enabled search, reviews, and directions."
    },
    {
      icon: Tag,
      title: "Exclusive Deals",
      description: "FREE tastings, 2-for-1 deals, and discount coupons. Save $5-$20 per person on wine tasting."
    },
    {
      icon: Compass,
      title: "Plan Your Trip",
      description: "Hotels, restaurants, Top 25 wineries, and things to do - plan your entire wine country adventure."
    },
    {
      icon: Users,
      title: "Share & Check-in",
      description: "Snap photos, check-in at wineries, earn rewards, and share your adventures with friends."
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-muted/50" data-testid="features-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <motion.div 
          className="text-center mb-10 sm:mb-16"
          {...fadeInUp}
        >
          <span className="overline text-primary mb-3 sm:mb-4 block text-xs sm:text-xs">Why Choose Us</span>
          <h2 className="font-serif text-2xl sm:text-4xl md:text-5xl text-primary mb-3 sm:mb-4">
            Wine Tasting is Now <span className="italic">Social</span>
          </h2>
          <p className="text-muted-foreground text-sm sm:text-base max-w-2xl mx-auto px-4">
            Everything you need to discover great wineries and get the best deals in wine country.
          </p>
        </motion.div>

        <motion.div 
          className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6"
          variants={staggerContainer}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          {features.map((feature) => (
            <motion.div
              key={feature.title}
              className="feature-card rounded-lg p-4 sm:p-8"
              variants={fadeInUp}
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-primary/10 flex items-center justify-center mb-3 sm:mb-4">
                <feature.icon size={20} className="text-primary sm:w-6 sm:h-6" />
              </div>
              <h3 className="font-serif text-base sm:text-xl text-primary mb-1.5 sm:mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-sm sm:text-sm">{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturesSection;
